// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".correlationMatrixPlotContainer {\n\twidth: 100%;\n\taspect-ratio: 1 / 1;\n\tmin-height: 150px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Content/Widgets/CorrelationMatrix/FullCorrelationMatrix/style.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,mBAAmB;CACnB,iBAAiB;AAClB","sourcesContent":[".correlationMatrixPlotContainer {\n\twidth: 100%;\n\taspect-ratio: 1 / 1;\n\tmin-height: 150px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"correlationMatrixPlotContainer": "correlationMatrixPlotContainer"
};
export default ___CSS_LOADER_EXPORT___;
